import { getParticipantRoundsForChallenge } from 'api/challenges-v2'
import type { GetUserChallengeRoundsResponse } from 'api/types'
import { createApiThunk } from 'utils/thunkWrapper'

interface ParticipantRoundsPayload {
  challengeId: string
  participantId: string
}

export const getParticipantRounds = createApiThunk<GetUserChallengeRoundsResponse, ParticipantRoundsPayload>({
  action: 'participantRounds/getParticipantRounds',
  request: (payload) => getParticipantRoundsForChallenge(payload.challengeId, payload.participantId),
})
